import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import { RefObject, useEffect, useRef, useState } from "react";
import "./App.css";
import iconCross from "./photos/cross-black2.svg";
import AutoExpandingTextArea from "./Components/AutoExpandingTextArea.tsx";

interface AIManualEntryProps {
  roomName: string;
  socket: any;
  showInfoMessage: (
    type: string,
    message: string,
    isAdd: boolean,
    duration?: string,
    isDelay?: boolean,
  ) => void;
  setAIRoomState: (state: string) => void;
  cameFromJoin: boolean;
  setRoomState: (state: string) => void;
  setCameFromJoin: (cameFromJoin: boolean) => void;
}

function AIManualEntry({
  roomName,
  socket,
  showInfoMessage,
  setAIRoomState,
  cameFromJoin,
  setRoomState,
  setCameFromJoin,
}: AIManualEntryProps) {
  const { t, i18n } = useTranslation();
  const [promptInput, setPromptInput] = useState<string>("");
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const addEntry = (prompt: string) => {
    if (promptInput !== "") {
      socket.emit("ai room add prompt", {
        roomName,
        prompt,
      });
      setPromptInput("");
      showInfoMessage("", t("added"), true, "short");
    }
    // document.getElementById("page").scrollIntoView();
  };

  function addEntryRender() {
    return (
      <div
        className="container"
        style={{ overflow: "auto", paddingRight: 10, paddingBottom: 10 }}
      >
        <AutoExpandingTextArea
          value={promptInput}
          onChange={setPromptInput}
          textareaRef={textAreaRef}
          placeholder={"SKRIV HER ..."}
          maxLength={280}
        />
        <div
          className="button-primary button-text-l shadow-black text-color-black box-button-center"
          onClick={() => {
            addEntry(promptInput);
          }}
        >
          {t("add")}
        </div>
      </div>
    );
  }

  const topBarRender = (): JSX.Element => (
    <div className="container-row lift-topbar">
      <div className="container-row-start">
        <div
          className="button-tertiary-m button-text-m text-color-black"
          onClick={() => {
            if (cameFromJoin) {
              setRoomState("start screen");
              setCameFromJoin(false);
            } else {
              setAIRoomState("done");
            }
          }}
          style={{ maxHeight: "32.5px" }}
        >
          {t("back")}
        </div>
      </div>
      <div className="text-h3 text-color-black left-margin-s text-force-break">
        {roomName}
      </div>
    </div>
  );

  //   If settings not defined send to setting
  return (
    <div className="App-header">
      {topBarRender()}
      {addEntryRender()}
    </div>
  );
}

export default AIManualEntry;
